<template>
  <span
    class="text-yellow-500"
    :id="'rating-' + id"
    :title="'Content Rating: ' + rating + '/5 stars'"
    v-tippy
  ></span>
</template>

<script>
export default {
  name: "RatingElement",
  props: ["rating", "id"],
  mounted() {
    this.determineHtml();
  },
  watch: {
    rating: function(val) {
      this.determineHtml();
    }
  },
  methods: {
    determineHtml() {
      var innerData = "";
      var fullStars = ~~this.rating;
      var halfStar = this.rating % 1 !== 0 ? 1 : 0;

      for (var i = 0; i < fullStars; i++) {
        innerData += '<i class="fas fa-star"></i>';
      }

      if (halfStar == 1) {
        innerData += '<i class="fas fa-star-half-alt"></i>';
      }

      var remainingStars = 5 - fullStars - halfStar;
      for (var i = 0; i < remainingStars; i++) {
        innerData += '<i class="far fa-star"></i>';
      }

      document.getElementById("rating-" + this.id).innerHTML = innerData;
    }
  }
};
</script>
